/**
 * Created by nijin on 26/6/17.
 */
import {Component, OnInit, ViewChild, Input} from "@angular/core";
import {AppModalComponent} from "../../../shared/modal/modal";
import {Validators, FormGroup, FormBuilder} from "@angular/forms";
import {GlobalValidator} from "../../../shared/validators/global-validator";
import {SchemaService} from "../../schema.service";
@Component({
  selector: 'nuc-save-schema',
  template: `
         <app-modal #popup>
    <div class="app-modal-header">
      <h3 class="modal-title text-center">{{'ONBOARD_THING.SCHEMA_POPUP.TITLE'| translate}}</h3>
    </div>
    <div class="app-modal-body">
      <form [formGroup]="form">
      <p>{{'ONBOARD_THING.SCHEMA_POPUP.DESCR'| translate}}</p>

      <div class="form-group" [ngClass]="{'has-error': formErrors.schemaName}">
        <input type="text" class="form-control" placeholder="eg: My Telematics Schema"
               aria-describedby="basic-addon1" id="new-schema-name" formControlName="schemaName">
        <div class="help-block">{{formErrors.schemaName | translate}}</div>
        <div class="clearfix"></div>
        <span class="error"></span>
      </div>
      <div class="form-group" [ngClass]="{'has-error': formErrors.schemaDescription}">
        <p>Provide a description for the new schema(optional)</p>
        <textarea class="form-control" formControlName="schemaDescription" placeholder="eg: Schema for the telematics module" [maxLength]="100"></textarea>  
        <div class="help-block">{{formErrors.schemaDescription | translate}}</div>
        <div class="clearfix"></div>
        <span class="error"></span>
      </div>
      </form>
    </div>
    <div class="app-modal-footer">
      <div class="btn-group-1 text-center">
        <button class="btn btn-secondary" id="cancel"(click)="resetSchemaName();modal.hide()" [disabled]="isSubmitted">
          {{'ONBOARD_THING.SCHEMA_POPUP.BTN_CANCEL' | translate}}</button>
        <button class="btn btn-primary" (click)="checkForDuplicate(form)" id="schema-save" [disabled]="isLoading">
          <span *ngIf="isLoading"><i class="fa fa-spinner fa-spin"></i></span>
          {{(hasError ?'COMMON.RETRY': 'ONBOARD_THING.SCHEMA_POPUP.BTN_SAVE') | translate}}</button>
      </div>
    </div>
  </app-modal>
     
   `
})
export class  SaveSchemaModal implements OnInit {
  @ViewChild('popup') modal: AppModalComponent;

  public form: FormGroup;
  public isSubmitted: boolean = false;
  public isLoading: boolean = false;
  public hasError: boolean = false;

  private wizardSubject: any;
  private nextStep: any;

  @Input() schemaModel: any;

  constructor(private fb: FormBuilder,
              private schemaService: SchemaService){

  }

  ngOnInit(){
     this.buildForm();
  }

  open(subject, nextStep){
    this.wizardSubject = subject;
    this.nextStep = nextStep;
    this.modal.open();
  }

  close(){
    this.modal.hide();
  }

  buildForm(){
    this.form = this.fb.group({
      'schemaName':['',[
        Validators.required,
        GlobalValidator.consecutiveSpace,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]],
      'schemaDescription':['',[
          Validators.maxLength(100)
      ]]
    })
    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
    this.onValueChanged();
  }

  formErrors = {
    schemaName:'',
    schemaDescription:''
  }
  onValueChanged(data?: any){
    if (!this.form) { return; }
    const form = this.form;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && (control.dirty && !control.valid || this.isSubmitted)) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }

  checkForDuplicate(form) {
    this.isSubmitted = true;
    this.onValueChanged();

    if(!form.valid) {
      this.isSubmitted = false;
      return;
    }
    this.isSubmitted = true;
    this.isLoading = true;

    this.schemaService.getCustomSchemaList({name:form.value['schemaName'].trim(),'is-search-exact':true})
      .subscribe((data)=>{
        if(data.items.length){
          this.formErrors.schemaName = 'ONBOARD_THING.SCHEMA_POPUP.VALIDATION.DUPLICATE';
          this.isLoading = false;
          this.isSubmitted = false;
          this.hasError = true;
          return;
        }
        else{
          this.saveSchema(form.value['schemaName'].trim(), form.value['schemaDescription']);
        }
      },
        (error)=>{
          this.isLoading = false;
          this.isSubmitted = false;
          this.hasError =true;
        }
      )

  }

  private  saveSchema(name, decsription?){
    this.schemaModel.schema.id =  undefined;
    this.schemaModel.schema.name = name;
    this.schemaModel.schema.description = decsription ? decsription.trim() : null;
    this.schemaModel.schema.accountId = undefined;
    this.schemaService.saveSchema(this.schemaModel.schema)
      .subscribe((response) =>{
          this.modal.hide();
          this.isSubmitted = false;
          this.resetSchemaName();
          this.isLoading = false;
          this.schemaService.setSelectedSchema(response);
          if(this.wizardSubject)
            this.wizardSubject.next(this.nextStep);

          this.modal.hide();
          this.hasError = false;

        },
        (err)=>{
          this.isSubmitted = false;
          this.isLoading = false;
          this.hasError = true;

        })
  }

  validationMessages ={
    'schemaName': {
      'required': 'ONBOARD_THING.SCHEMA_POPUP.VALIDATION.REQUIRED',
      'consecutiveSpace': 'CMN_VALIDATIONS.CONSECUTIVE_SPACE',
      'minlength': 'CMN_VALIDATIONS.MIN_LENGTH_TWO',
      'maxlength': 'ONBOARD_THING.SCHEMA_POPUP.VALIDATION.MAX_LENGTH'

    },
    'schemaDescription':{
      'minlength':'CMN_VALIDATIONS.MIN_LENGTH_TWO',
      'maxlength':'ONBOARD_THING.SCHEMA_POPUP.VALIDATION.MAX_LENGTH'

    }
  }

  resetSchemaName(){
    this.form.reset();
  }
}



// WEBPACK FOOTER //
// ./src/app/schema/shared/modal/save.schema.modal.ts